import { connect } from 'react-redux'
import * as UserActions from '../stores/user/actions';
import ProfileEdit from '../components/profile_edit';

const mapStateToProps = (state) => {
  return {
    user: state.default.user
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onUpdateAccount: (name, headline, makePublic) => {
      dispatch(UserActions.update(name, headline, makePublic));
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileEdit);



// WEBPACK FOOTER //
// ./src/containers/profile_edit.js